








    import { Component, Vue, Watch } from 'vue-property-decorator'
	import Navbar from '@/components/Navbar.vue'
    import * as Sidebar from '@/assets/scripts/SidebarModule'
    import * as highlight from '@/assets/scripts/HighlightModule'

	@Component({
		name: 'App',
		components: {
			Navbar
		},
	})
	export default class App extends Vue {

		mounted() {
            new Sidebar.SidebarClass()
        }
        @Watch('$route', { immediate: true, deep: true})
        onUrlChange() {
              // fix for global init of highlight
            new highlight.Highlight()
        }

	}


